import Vue from "vue";
import {api as configs} from "@/app/config";
import {getData} from "@/app/plugins/utils";

export const getLogTransations = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'transaction_logs'+payload).then(getData)
}

export const getTransationsRisk = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'transaction_risk'+payload).then(getData)
}

export const getTransationsOnlineRisk = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'transaction_online_risk'+payload).then(getData)
}

export const getTransationsRiskV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/transaction_risk'+payload).then(getData)
}

export const postLogTransations = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'transaction_logs', payload).then(getData)
}

export const getTransations = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'transaction'+payload).then(getData)
}

export const getTransationsV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/transaction'+payload).then(getData)
}

export const getTypeAdjust = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_adjust_type'+payload).then(getData)
}

export const getReceables = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'receivable'+payload).then(getData)
}

export const getReceablesV3 = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'v3/receivable'+payload).then(getData)
}

export const getMarketplaceReceivables = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'marketplace_receivable'+payload).then(getData)
}

export const getTransationsFee = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'transaction_fee'+payload).then(getData)
}

export const getPaymentAdjust = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_adjust'+payload).then(getData)
}

export const putPaymentAdjust = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'payment_adjust_config/'+payload.id, payload).then(getData)
}

export const postPaymentAdjust = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment_adjust_config', payload).then(getData)
}

export const postCreatedPin = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'risk_analysis/save_pin', payload).then(getData)
}

export const createTransationsOnlineRisk = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'risk_analysis/init', payload).then(getData)
}

export const getPayment = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment'+payload).then(getData)
}

export const getListPayment = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment/list_payment'+payload).then(getData)
}

export const getAdjustsDetailsPayment = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment/adjusts_details',payload).then(getData)
}

export const getEffectContactDetailsPayment = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment/contract_effect_details',payload).then(getData)
}

export const getReceivablesDetailsPayment = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment/receivables_details',payload).then(getData)
}

export const getStatisticsTotalPayment = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment/statistics_total'+payload).then(getData)
}

export const getStatisticsAdjustCredit = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment/statistics_adjust_credit'+payload).then(getData)
}

export const getStatisticsAdjustDebit = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment/statistics_adjust_debit'+payload).then(getData)
}

export const getStatisticsContractEffect = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment/statistics_contract_effect'+payload).then(getData)
}

export const getStatisticsSplit = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment/statistics_splits'+payload).then(getData)
}

export const getExportPayment = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment/export'+payload).then(getData)
}

export const postGeneratePaymentMkt = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'marketplace_receivable/paid', payload).then(getData)
}

export const postGeraRemessaPayment = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment_batche', payload).then(getData)
}

export const postGeraRemessaPaymentJob = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment_batche_job', payload).then(getData)
}

export const getStatisticsPaymentLink = (payload = '') => {
  return Vue.http.get(configs.baseUrl+`payment_link/statistics${payload}`).then(getData)
}

export const getSubscriptions = (payload = '') => {
  return Vue.http.get(configs.baseUrl+`payment_link_subscription${payload}`).then(getData)
}

export const getPaymentLink = (payload = '') => {
  return Vue.http.get(configs.baseUrl+`payment_link${payload}`).then(getData)
}

export const postCreatePaymentLink = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment_link', payload).then(getData)
}

export const putPaymentLink = (id, payload = '') => {
  return Vue.http.put(configs.baseUrl+'payment_link/'+id, payload).then(getData)
}

export const deletePaymentLink = (id, payload = '') => {
  return Vue.http.delete(configs.baseUrl+'payment_link/'+id, payload).then(getData)
}

export const postGeraRemessaPaymentV3 = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'v3/payment_batche', payload).then(getData)
}

export const getPaymentExport = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_batche'+payload).then(getData)
}

export const getPaymentAdjustConfig = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_adjust_config'+payload).then(getData)
}

export const postPaymentAdjustConfig = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment_adjust_config', payload).then(getData)
}

export const postCancelTransaction = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'cancel_transaction', payload).then(getData)
}

export const postDocumentCancel = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'cancel_transaction_document', payload).then(getData)
}

export const putPaymentAdjustConfig = (payload = '') => {
  return Vue.http.put(configs.baseUrl+'payment_adjust_config/'+payload.id, payload).then(getData)
}

export const deletePaymentAdjustConfig = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'payment_adjust_config'+payload).then(getData)
}

export const getMarkupRepresentante = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_rate'+payload).then(getData)
}

export const postAnticipationSchedule = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'schedule_anticipation/anticipation', payload).then(getData)
}

export const getScheduleAnticipation = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'schedule_anticipation'+payload).then(getData)
}

export const canAddScheduleAnticipation = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'schedule_anticipation/can_add'+payload).then(getData)
}

export const deleteScheduleAnticipation = (payload = '') => {
  return Vue.http.delete(configs.baseUrl+'schedule_anticipation'+payload).then(getData)
}

export const descripitonPdfScheduleAnticipation = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'schedule_anticipation/descriptionPdf'+payload).then(getData)
}

export const postScheduleAnticipation = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'schedule_anticipation/schedule'+payload, payload).then(getData)
}

export const getPaymentSplitEC = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_ec_batch_split'+payload).then(getData)
}

export const postPaymentSplitEC = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment_ec_batch_split', payload).then(getData)
}

export const getPaymentSplitMarketplace = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_marketplace_batch_split'+payload).then(getData)
}

export const postPaymentSplitMarketplace = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'payment_marketplace_batch_split', payload).then(getData)
}

export const getListSchedule = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'schedule_anticipation/show_schedule'+payload).then(getData)
}

export const getExportReceivables = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'export/receivables'+payload).then(getData)
}

export const getPaymentBankSlipBatche = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_bank_slip/batche'+payload).then(getData)
}

export const getPaymentBankSlipBatcheExport = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'payment_bank_slip/batche_export'+payload).then(getData)
}

export const getClearSale = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'risk_analysis/get_status_clear_sale/'+payload).then(getData)
}

export const getCommentsRisk = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'risk_analysis/get_comments_risk?id='+payload).then(getData)
}

export const postCreateClearSale = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'risk_analysis/create_status_clear_sale/', payload).then(getData)
}

export const postCreateCredify = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'risk_analysis/create_status_create_credify/', payload).then(getData)
}

export const postApproveRiskTransaction = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'risk_analysis/approve/', payload).then(getData)
}

export const postRiskComment = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'risk_analysis/comment/', payload).then(getData)
}